import type { QueryResult } from '../types/QueryInput'
import { useDeepCompareEffect } from '../useDeepCompareEffect'

/**
 * Just a common wrapper so the we can handle effectively on the effect of  document or list result
 * @param effect
 * @param queryDependency
 */
export function useQueryEffect<T = any>(effect: () => void, queryDependency: QueryResult<T>) {
  const data = {
    loading: queryDependency?.loading,
    networkStatus: queryDependency?.networkStatus,
    error: queryDependency?.error,
    data: queryDependency?.data,
  }

  useDeepCompareEffect(() => {
    effect()
  }, [data])
}
